import { useSetJaneDeviceId } from '../common/hooks/useSetJaneDeviceId';

export const SetJaneDeviceId = () => {
  useSetJaneDeviceId();

  return null;
};
